import React from "react";

const Projects = (props) => {
  return (
    <div
      id={props.isNightMode ? "dark" : "light"}
      className="project-genel-container">
      <div className="title">
        {" "}
        <h2 id={props.isNightMode ? "dark" : "light"}>Projects</h2>
      </div>
      <div className="projeler">
        <div
          id={props.isNightMode ? "darkproject" : "light"}
          className="random-jokes">
          <h3 id={props.isNightMode ? "dark" : "light"}>
            What's your favorite movie ?
          </h3>
          <p id={props.isNightMode ? "dark" : "light"}>
            You can save what you want to watch in an application that contains
            popular movies and remove them from your list after watching them.
          </p>
          <div className="buttonlar">
            <div className="button">
              {" "}
              <li className={props.isNightMode ? "dark" : "light"}>react</li>
            </div>
            <div className="button">
              {" "}
              <li className={props.isNightMode ? "dark" : "light"}>vercel</li>
            </div>
            <div className="button">
              {" "}
              <li className={props.isNightMode ? "dark" : "light"}>axios</li>
            </div>
            <div className="button">
              {" "}
              <li className={props.isNightMode ? "dark" : "light"}>router</li>
            </div>
          </div>
          <div className="projects-links">
            <a
              id={props.isNightMode ? "dark" : "light"}
              href="https://github.com/Busemutluoglu/fsweb-s10g3-redux-watchlist">
              View on Github
            </a>
            <a
              id={props.isNightMode ? "dark" : "light"}
              href="https://encokizlenenfilmler.vercel.app/">
              Go to app →
            </a>
          </div>
          <img
            className="randomjokes"
            src="random jokes.svg"
            alt="project-photo"
          />
        </div>
        <div
          id={props.isNightMode ? "darkproject" : "style"}
          className="random-jokes"
          /* style={{ backgroundColor: "#D9F6F1" }} */
        >
          <h3 id={props.isNightMode ? "dark" : "light"}>Gratitude Diary</h3>
          <p id={props.isNightMode ? "dark" : "light"}>
            What is a Gratitude Diary? Gratitude diary, positive in one's life
            focus on things, feel gratitude and gratitude It is a kind of diary
            in which he often writes things for which he is grateful. It is a
            simple but highly effective method for mental well-being and Helping
            a person develop a positive outlook on life it could be.
          </p>
          <div className="buttonlar">
            <div className="button">
              {" "}
              <li className={props.isNightMode ? "dark" : "light"}>react</li>
            </div>
            <div className="button">
              {" "}
              <li className={props.isNightMode ? "dark" : "light"}>redux</li>
            </div>
            <div className="button">
              {" "}
              <li className={props.isNightMode ? "dark" : "light"}>vercel</li>
            </div>
            <div className="button">
              {" "}
              <li className={props.isNightMode ? "dark" : "light"}>axios</li>
            </div>
            <div className="button">
              {" "}
              <li className={props.isNightMode ? "dark" : "light"}>router</li>
            </div>
          </div>
          <div className="projects-links">
            <a
              id={props.isNightMode ? "dark" : "light"}
              href="https://github.com/Busemutluoglu/fsweb-s10-challenge">
              View on Github
            </a>
            <a
              id={props.isNightMode ? "dark" : "light"}
              href="https://minnetgunlugu.vercel.app/">
              Go to app →
            </a>
          </div>
          <img
            className="randomjokes2"
            src="areubored.svg"
            alt="project-photo"
          />
        </div>
      </div>
    </div>
  );
};

export default Projects;
